import React from "react";
import {Button, Layout} from "antd";
import {Content} from "antd/lib/layout/layout";
import {NavLink} from "react-router-dom";
import {ROUTES as ROUTES_CONFIG} from "../../config/constants";
import {PATH} from "../../config";

const Page404 = () => {
    return (
        <Layout className="pt-162 min-h-calc-head h-full page404" style={{background: `#1c1a42 url(${PATH + 'page404-bg.png'}) no-repeat center center / cover`}}>
            <Content className="container mx-auto pl-10 pr-10 bg-transparent h-full page404-container">
                <div className="page404-content">
                    <h2 className="text-white font-mont page404-symbol">404</h2>
                    <h3 className="text-white font-mont font-bold page404-title">Oh no! We’ve lost this page</h3>
                    <p className="font-normal font-mont page404-text">Apologies, but the page you are looking does not exist or has been moved.</p>
                    <NavLink to={ROUTES_CONFIG.homePage.path} className="inline-block">
                        <Button className="border-0 text-white rounded-10px uppercase font-bold font-mont page404-btn">BACK TO HOMEPAGE</Button>
                    </NavLink>
                </div>
            </Content>
        </Layout>
    )
}

export default Page404;